import { forwardRef } from 'react';
import BaseInput from './BaseInput';

const ApplicationAmountInput = forwardRef(function ApplicationAmountInput({ ...rest }, ref) {
  return <BaseInput className="py-3" type="number" icon={<span>$</span>} ref={ref} {...rest} />;
});

export default ApplicationAmountInput;
